/**
 * Router Component
 * 
 * Main application router that handles route configuration and page rendering.
 * Implements lazy loading for performance and manages global layout components.
 * 
 * Interactions:
 * - Uses react-router-dom for client-side routing
 * - Implements React.lazy() for code-splitting and performance optimization
 * - Coordinates with Header and Footer for consistent layout across pages
 * - Imports route configuration from separate config file
 * - Applies global styles and layout structure to all pages
 * - Uses Suspense for loading states during page transitions
 */

import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      {/* <Footer /> */}
    </Suspense>
  );
};

export default Router;
